<template>
    <div class="card">
        <div class="card-body">
            <b-row>
                <b-col cols="4">
                    <div style="text-align: center; padding-left: 10%; padding-right: 10%;" class="height: 20rem;">
                        <b-progress striped max=100 height="2rem" style="border 1px solid lightgrey; !important" >
                            <b-progress-bar :value="status.process_completion" variant="success"></b-progress-bar>
                        </b-progress>
                        <h4><strong>{{status.process_completion}}%</strong> Process Complete</h4>
                    </div>
                </b-col>

                <b-col cols="4" style="text-align: center; padding-left: 5%; padding-right: 5%;">
                    <div class="height: 2rem;">
                        <i style="font-size: 2rem; color: limegreen;" class="far fa-calendar-alt"></i>
                    </div>
                    <h4><strong>{{status.inspection_days}}</strong> Projected Days Until Inspection</h4>
                </b-col>

                <b-col cols="4" style="text-align: center; padding-left: 5%; padding-right: 5%;">
                    <div class="height: 2rem;">
                        <i style="font-size: 2rem; color: red;" class="far fa-question-circle"></i>
                    </div>
                    <h4><strong>{{status.queries}}</strong> Queries Requiring Response</h4>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { licenseAppState, licenseAppMethods } from '@/state/helpers.js'
//eslint-disable-next-line
import { parseISO, differenceInCalendarDays } from 'date-fns';
export default {
    data:() => ({
        status:{
            process_completion: 0,
            inspection_days: 0,
            queries: 0,
            state: '',
        }
    }),
    computed:{
        ...licenseAppState,
        hasAppData(){
            if(this.app_data == null){
                return false;
            }
            else{
                return true;
            }
        }
    },
    watch:{
        app_data(){
            this.setStatusData();
        }
    },
    methods:{
        ...licenseAppMethods,
        setStatusData(){
            let total = this.app_data.steps.length;
            let steps_completed = 0;
            let queries_action = 0;
            this.app_data.steps.forEach(step => {
                if(step.status == 'complete'){
                    steps_completed++;
                }
                if(step.action_required){
                    queries_action++;
                }
            })
            let percentage = (steps_completed/total)*100;

            this.status.queries = queries_action;
            this.status.process_completion = Math.floor(percentage);
            this.status.inspection_days = differenceInCalendarDays(parseISO(this.app_data.estimated_inspection_date), new Date());
        },
        /*updateStepData(){
            this.loadAppData();
        },*/
    },
    mounted(){
        if(this.hasAppData){
            this.setStatusData();
        }
        //this.$eventHub.$on('updateSteps', this.updateStepData);
        
    },
}
</script>

<style>

</style>